<div class="mech-diag-content">
	<div *ngIf="component">
		<app-dvs-chart *ngFor="let ci of ciCriticals" [error]="ci.errormessage" [options]="ci.options" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		<div *ngIf="!showOptional" class="optional-expander">
			<button (click)="enableOptionals()" class="btn btn-primary">Show optional CIs <i class="icon-down-open"></i></button>
		</div>
		<div [hidden]="!showOptional">
			<app-dvs-chart *ngFor="let ci of ciOptionals" [error]="ci.errormessage" [options]="ci.options" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		</div>
	</div>
	<div class="trend-options">
		<div class="row justify-content-sm-center">
			<div class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label">
						<input [(ngModel)]="useXAxisDate" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						X-Axis by date
					</label>
				</div>
			</div>
			<div *ngIf="!asset.is_fixed" class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label">
						<input [(ngModel)]="compareRegimes" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						Compare to regime
					</label>
				</div>
			</div>
			<div *ngIf="dataExceedsLimit" class="col-sm-auto">
				<div class="form-check">
					<label class="form-check-label" title="Chart is normally limited to the last 15k points. Viewing all data may could cause your browser to crash.">
						<input [(ngModel)]="unlimitedChart" (ngModelChange)="RefreshChart()" class="form-check-input" type="checkbox">
						Show all data
					</label>
				</div>
			</div>
		</div>
	</div>
</div>